/*
 * Copyright (c) 2019 - Bas Milius <bas@mili.us>
 *
 * This file is part of the Latte Framework package.
 *
 * For the full copyright and license information, please view the
 * LICENSE file that was distributed with this source code.
 */

Latte.core.register(() =>
{

	Latte.action.on("hub:notifications:cancel", ({appNamespace, notificationId}) =>
	{
		const title = Latte.i18n.translate("hub-notifications", "Cancel notification?");
		const body = Latte.i18n.translate("hub-notifications", "The notification can only be cancelled if it's not send within the next 5 minutes. Are you sure?");

		Latte.ui.message.confirm(title, body).then(result =>
		{
			if (result.button !== Latte.ui.message.Buttons.OK)
				return;

			Latte.api.request(`/api/hub/apps/${appNamespace}/notifications/${notificationId}`, {method: "DELETE"}).then(r =>
			{
				Latte.action.dispatch("data-tables:refresh");

				if (r.status === 204)
				{
					return Latte.ui.snackbar.create({
						location: Latte.ui.snackbar.Locations.TOP,
						message: Latte.i18n.translate("hub-notifications", "Notification successfully cancelled.")
					});
				}

				r.json().then(r =>
				{
					return Latte.ui.snackbar.create({
						location: Latte.ui.snackbar.Locations.TOP,
						message: Latte.i18n.translate("hub-notifications", r.previous.error_description)
					});
				});
			});
		});
	});

});
